import fly from "../config/flyio";

export default {
  applySubmit(data) {
    return fly.post("/VHISLoveYourSelf/CheckSubmit", data);
  },
  getDistrict() {
    return fly.get("/VHISLoveYourSelf/GetDistrict");
  },
  getQuoteData(appNo){
    return fly.get("/VHISLoveYourSelf/BackToApply?AppNo="+appNo);
  },
  getStatus(appNo){
    return fly.get("/VHISLoveYourSelf/CheckPersonStatus?AppNo="+appNo);
  }
};
